export class callbacksToDial {

    constructor(callbacksObj) {
        this.day             = callbacksObj.Day;
    }

}